
import { mapState, mapActions } from "vuex";
import LoadingCollapse from "@/components/LoadingCollapse.vue";

export default {
  head() {
    let url = "https://startupcambodia.gov.kh/";
    if (process.browser) url = window.location.href;

    let img = this.resource?.thumbnail;
    let title = this.resource?.name || "Resource Detail";
    const descHtml = this.resource?.detail || "";
    const desc = descHtml.replace(/<[^>]+>/g, "").slice(0, 255);

    return {
      title,
      meta: [
        { hid: "og:url", content: url },
        { hid: "og:title", property: "og:title", content: title },
        { hid: "og:type", property: "og:type", content: "article" },
        { hid: "image", name: "image", content: img },
        { hid: "og:image", property: "og:image", content: img },
        { hid: "description", name: "description", content: desc },
        {
          hid: "og:description",
          property: "og:description",
          content: desc,
        },
        {
          hid: "twitter:image",
          property: "twitter:image",
          content: img,
        },
        {
          hid: "twitter:title",
          property: "twitter:title",
          content: title,
        },
        {
          hid: "twitter:description",
          property: "twitter:description",
          content: desc,
        },
        {
          hid: "twitter:card",
          property: "twitter:card",
          content: "summary_large_image",
        },
      ],
    };
  },
  components: { LoadingCollapse },
  data() {
    return {
      bannerUrl: "/images/resource/banner.png",
      fullPage: true,
      resource: {},
      isSave: false,
      blogs: [],
    };
  },
  computed: {
    ...mapState("resource-page", ["isLoading"]),
    ...mapState("resource", ["isLoading"]),
    ...mapState("saving-list", { isSaving: "isLoading" }),

    breadCrumbs() {
      return [
        { homePage: true, text: this.$t("breadcrumb.home"), to: "/" },
        { text: this.$t("breadcrumb.resources"), to: "/resource/category" },
        {
          text: this.$route.params.resource
            ? this.$t(`menu.resource.${this.$route.params.resource}`)
            : "",
          to: `/resource/category/${this.$route.params.resource || ""}`,
        },
      ];
    },
    shareOptions() {
      return [
        {
          text: this.$t("menu.share_to.linkedin"),
          icon: "mdi-linkedin",
          type: "linkedin",
        },
        {
          text: this.$t("menu.share_to.facebook"),
          icon: "mdi-facebook",
          type: "facebook",
        },
        {
          text: this.$t("menu.share_to.twitter"),
          icon: "mdi-twitter",
          type: "twitter",
        },
        {
          text: this.$t("menu.share_to.telegram"),
          icon: "mdi-send-circle",
          type: "telegram",
        },
        {
          text: this.$t("menu.share_to.clipboard"),
          icon: "mdi-content-copy",
          type: "copy",
        },
      ];
    },
    isSaved() {
      return this.resource?.is_saved;
    },
    saveIcon() {
      return this.isSaved ? "mdi-bookmark" : "mdi-bookmark-outline";
    },
    fileURL() {
      const DOMAIN2SHARE = this.$config.SHARE_URL || window?.location?.origin;
      return DOMAIN2SHARE + "/resource/category/blog/" + this.resource.id;
    },

    authorName() {
      return this.resource?.created_by == null
        ? this.$t("n_a1")
        : this.resource?.created_by.first_name +
            " " +
            this.resource?.created_by.last_name;
    },

    authorPhoto() {
      return (
        this.resource?.created_by?.photo_thumbnail || "/images/default-user.png"
      );
    },

    authorOccupation() {
      return this.resource?.created_by?.occupation || "";
    },

    authorBio() {
      return this.resource?.created_by?.bio || "";
    },
    authorSkills() {
      var displaySkills = [];
      var skills = this.resource?.created_by?.skills;

      if (skills) {
        skills.forEach((skill) => {
          this.$isKm()
            ? displaySkills.push(skill.name_km)
            : displaySkills.push(skill.name);
        });

        if(skills.length>3){
          const newArr = displaySkills.slice(0,3);
          displaySkills= newArr;
          displaySkills.push(`+ ${skills.length - newArr.length} ${ this.$t("others")}`)
        }
      }

      return displaySkills;
    },
  },
  methods: {
    ...mapActions("resource-page", { getResourcePage: "get" }),
    ...mapActions("resource", { getResourceById: "getById" }),
    ...mapActions("saving-list", { toggleBookmark: "create" }),
    ...mapActions("resource", ["getResourceByCategory"]),

    toggleSave() {
      const payload = { type: "blog", ref_id: this.resource.id };
      this.toggleBookmark({ payload })
        .then(() => {
          this.fileInfo.is_saved = !this.fileInfo.is_saved;
          this.$toast.show(this.$t("success"));
        })
        .catch((error) => {
          let message = error.response?.data?.message;
          this.$toast.error(message);
        });
    },
    goTop() {
      let options = { duration: 100, offset: 70, easing: "linear" };
      this.$vuetify.goTo("#cardContent", options);
    },
    copyLink() {
      const url = this.fileURL;
      if (!process.browser) return;
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(url);
        this.$toast.show(this.$t("message.copied"));
        return;
      }

      const input = document.createElement("input");
      input.value = url;
      input.style.position = "fixed";
      input.style.left = "-999999px";
      input.style.top = "-999999px";
      document.body.appendChild(input);
      input.focus();
      input.select();
      document.execCommand("copy");
      input.remove();
      this.snackbar = true;
    },
    shareTo(resource, type) {
      if (type == "copy") {
        this.copyLink();
        return;
      }

      const DOMAIN2SHARE = this.$config.SHARE_URL || window?.location?.origin;
      let url = DOMAIN2SHARE + "/resource/category/blog" + this.resource.id;
      let text = resource.name;
      const shareURL = {
        linkedin: `https://www.linkedin.com/shareArticle?mini=true&title=${text}&url=${url}`,
        facebook: `https://facebook.com/sharer/sharer.php?u=${url}`,
        twitter: `https://twitter.com/share?url=${url}&text=${text}`,
        telegram: `https://t.me/share/url?url=${url}&text=${text}`,
      };

      if (!!shareURL[type]) window.open(shareURL[type]);
    },
    toggleSaveFile() {
      const payload = { type: "blog", ref_id: this.resource.id };
      this.toggleBookmark({ payload })
        .then(() => {
          this.resource.is_saved = !this.resource.is_saved;
          // this.savingFileId = null;
          this.$toast.show(this.$t("success"));
        })
        .catch((error) => {
          let message = error.response?.data?.message || error;
          this.$toast.error(message);
          // this.savingFileId = null;
        });
    },
    forceRerender() {
      this.componentKey += 1;
    },

    async searchResource(page = 1) {
      // this.forceRerender();

      const category = this.categorySlug;
      const { search, sectors } = this.$route.query;
      let options = {
        params: { category, search, page, sectors, page_size: 5 },
      };
      return await this.getResourceByCategory(options)
        .then((res) => {
          // this.resources = this.$common.cloneJSON(res.data);
          this.blogs = this.$common.cloneJSON(res.data);
          console.log("searchResource=====",res);
          // this.totalPage = res.total_page;
          // this.itemCount = res.item_count;
          // this.noItem = !res.data.length;
        })
        .catch((e) => {
          // this.noItem = true;
          this.blogs = Object.assign([], []);
          // this.totalPage = 1;
        });
    },
  },
  created() {
    // watch the params of the route to fetch the data again
    this.$watch(
      () => this.$route.params,
      () => {
        let { resourceId } = this.$route.params;
        this.getResourceById({ id: resourceId })
          .then((res) => {
            this.resource = Object.assign({}, res);
            this.goTop();
          })
          .catch((e) => {});
        // fetch article list
        // const { page } = this.$route.query;
        // this.search.keyword = search;
        // this.search.sectors = sectors?.split(",") || [];
        // this.searchResource(page);
      },
      // fetch the data when the view is created and the data is
      // already being observed
      { immediate: true }
    );
  },
  async fetch() {
    // const { page } = this.$route.query;
    // await this.searchResource(page);
  },
};
